import React from "react";
import { connect } from "react-redux";
import * as VstuiIcons from "@vitalsource/vstui-icons";
import { selectors as brandSelectors } from "../../../../../redux/brand";
import { selectors as userSelectors } from "../../../../../redux/user";
import { t } from "../../../../core/translate";
import { safeRedirect, ssoToOldOnlineURL } from "../../../../utils/location";
import { ThemedButton } from "./styles";

const CustomButton = ({ currentUser, enabled, sso, url, label, icon }) => {
  if (!enabled) {
    return null;
  }

  const IconClass = icon && VstuiIcons[icon];
  return (
    <ThemedButton
      color="white"
      href={url}
      iconStart={IconClass && <IconClass />}
      onClick={e => {
        e.preventDefault();
        sso
          ? ssoToOldOnlineURL(url, true, currentUser)
          : safeRedirect(url, "_blank");
      }}
      naked
      target="_blank"
      tooltipPlacement="bottom"
    >
      {label}
    </ThemedButton>
  );
};

const mapStateToProps = state => ({
  currentUser: userSelectors.getUser(state),
  enabled: brandSelectors.getBrandValue(
    state,
    "Header.CustomButton.enabled",
    true
  ),
  sso: brandSelectors.getBrandValue(state, "Header.CustomButton.sso", true),
  label: brandSelectors.getBrandValue(
    state,
    "Header.CustomButton.label",
    t("global-bar.store", "Store")
  ),
  icon: brandSelectors.getBrandValue(state, "Header.CustomButton.icon", "Tag"),
  url: brandSelectors.getBrandedCustomButtonUrl(state, {
    utm_medium: "bookshelf-nav"
  })
});

export default connect(mapStateToProps, null)(CustomButton);
